
	// @ts-nocheck (визард собирается, а юарм - нет, и наоборот. Надо что-то делать)
	declare var require: (...args: any[]) => void; // просто хак без лишних приседаний чтобы реквайр не ломал компиляцию

	// Надо было всё же найти нативный готовый дейтпикер который умеет
	// ручной ввод, маску, норм выбор годов, время отдельно, дату отдельно и т.п.
	// а то тут костыль на костыле получился со временем, всё сложно :(

	import ctrlMixins from '@uarmSrc/controls/_mixins.js'
	import utilDate from '@uarmSrc/util-date.js'
	import { UarmCtrlComponentMeta } from '@uarmSrc/types';
	// @ts-ignore
	import { ctrlParamsForAll } from '@uarmSrc/controls/_common-stuff.ts';

	// Подключаем ресурсы жиквери
	// с проверкой на то что подгружена "правильная версия" чтобы не было конфликтов например с живыми графиками
	// АХТУНГ! по уму это надо перенести в created, с подгрузкой скриптов по http
	var loadedJqueryVersion;
	var _jquery = require('jquery/dist/jquery.min.js');
	if (!window.jQuery || window.jQuery.fn.jquery !== loadedJqueryVersion) {
		window.$ = _jquery;
		window.jQuery = _jquery;
		loadedJqueryVersion = window.jQuery.fn.jquery;
		console.log('jQuery loaded to global variable for datepicker, v=' + window.jQuery.fn.jquery);
	}
	if (typeof window.jQuery.ui === 'undefined') {
		require('./jquery-ui.min.js');
	}

	require('./jquery-ui.min.css');
	require('./images/ui-icons_444444_256x240.png');
	require('./images/ui-icons_555555_256x240.png');
	require('./images/ui-icons_777620_256x240.png');
	require('./images/ui-icons_777777_256x240.png');
	require('./images/ui-icons_cc0000_256x240.png');
	require('./images/ui-icons_ffffff_256x240.png');

	/** Это наше кастомное поле, т.е. vue не использует их в конфигурации компонента */
	const meta: UarmCtrlComponentMeta = {
		title: 'Дата/время',
		params: {
			enableTime: {
				name: 'Время',
				editType: 'checkbox'
			},
			isRange: {
				name: 'Поиск по диапазону',
				editType: 'checkbox',
				tip: 'При фильтрации будет два поля',
				onlyForViewTypes: ['filter'],
			},
			defaultDateModifiers: {
				name: 'Модификатор даты по умолчанию',
				isAdvanced: true,
				tip: `Для ситуаций, когда значение должно быть вбито, например, "вчера", "завтра" и т.п.
				<p>Для дат в прошлом вписываются отрицательные значения, например, "-1".</p>
				<h3>Работает только с обязательными полями и в карточке новой записи</h3>`,
				editType: 'defaultDateModifiersEd',
				// onlyForViewTypes: ['filter'],
			},
			...ctrlParamsForAll,
		}
	}

	export default {
		name: 'JqueryUIDatepicker',
		meta,
		props: {
			value: {},
			is_double: {
				default: false,
				type: Boolean,
			},
			range_search_type: { // при поиске по диапазону сюда передается 'min' или 'max'
				type: String
			},
		},
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		methods: {
			clearField: function(){
				// console.log('Datetime clearField() ' + this.$props.range_search_type);
				// this.c_val = null;
				this.getInp().value = '';
				this.timeHours = this.getDefaultTimeHours();
				this.timeMinutes = this.getDefaultTimeMinutes();
				this.setDate(null);
			},
			getTimeTitle: function(){
				return this.c_val ? '' : 'Необходимо выбрать дату';
			},
			getInp: function(){
				return this.$refs.inputRef;
			},
			onInput: function(){},
			onFocus: function(){
				var v = this.getInp().value;
				if (utilDate.humanDateIsValid(v)) {
					this.$data.dpValOnFocus = v;
				}
			},
			onBlur: function(evt){
				// Проверка на relatedTarget нужна чтобы отличить нормальный blur (клик на другом элементе или tab)
				// от блера при выборе из календаря. различать их надо потому что в случае выбора из календаря
				// потеря фокуса случается раньше присвоения значения
				var vm = this;

				if (!evt.relatedTarget || evt.relatedTarget.className.indexOf('ui-state-default') === -1) {
					console.log('Blur вызванный кликом вовне поля или табом, а не выбором из календаря');
					var inp = vm.getInp();
					if (inp.value && utilDate.humanDateIsValid(inp.value) === true) {
						vm.setDate(inp.value);
						vm.invokeTimeWatcherForMaxDate();
						// this.c_val_date = inp.value
						// window.$(vm.getInp()).datepicker('setDate', val)
					}
					// если при потере фокуса ничего путного не вбито,
					// возвращаем последнее удачное значение (которое было при фокусе) либо просто обнуляем
					else if (vm.$data.dpValOnFocus) {
						inp.value = vm.$data.dpValOnFocus;
					}
					else {
						inp.value = '';
					}
				}
				else {
					console.log('Blur вызванный выбором из календаря');
				}
				// setTimeout(function() {})
			},
			setDate: function(v){
				if (v && v.split('.')[2] < 1750){
					let nv = v.split('.');
					nv[2] = 1750;
					nv = nv.join('.');
					this.$refs.inputRef.value = nv
					this.c_val_date = nv;
				}else{
					this.c_val_date = v;
				}
			},
			onInputTime: function(evt) {

			},
			onFocusTime: function(evt) {

			},
			onBlurTime: function(evt) {

			},
			/**
			 Добить строку (str) до требуемой длины (len, по умолчанию 2) указанными символами (ch, по умолчанию '0').
			 Пример использования:
			 UTIL.leftpad(3) // => '03'
			 UTIL.leftpad('foo',6,'>') // => '>>>foo'
			 */
			leftpad: function(str, len, ch) {
				str = String(str);
				if (typeof len === 'undefined') {
					len = 2
				}
				if (typeof ch === 'undefined') {
					ch = '0'
				}
				var i = -1;
				len = len - str.length;
				while (++i < len) {
					str = ch + str;
				}
				return str;
			},
			getDefaultTimeHours: function(){
				return this.$props.range_search_type === 'max' ? '23' : '00';
			},
			getDefaultTimeMinutes: function(){
				return this.$props.range_search_type === 'max' ? '59' : '00';
			},
			invokeTimeWatcherForMaxDate: function() {
				var vm = this;
				// мегакривой (как и всё в этом файле, сорри) код который гарантирует что отображаемая дата попадет в модель
				// nextTick нужны потому что каждое обновление сначала попадает в родительский компонент а потом спускается через пропс
				// таким образом последовательный немедленный вызов setDate, вотчера часов и вотчера минут не взлетят
				// сделать полное и атомарное обновление даты и из строки dateStr и из текущих значений timeHours и timeMinutes ничего не сломав трудно
				// приходится делать три обновления модели подряд
				// от такая фигня :(
				// ограничил применение костыля фильтром и вторым полем, надеюсь в карточку дефект когда время не то что в выпадушках а 00:00 не пролезет
				if (vm.$props.range_search_type === 'max') {
					vm.$nextTick(function() {
						getTimeWatcher(true).call(vm, vm.$data.timeHours);
						vm.$nextTick(function() {
							getTimeWatcher(false).call(vm, vm.$data.timeMinutes);
						})
					})
				}
			},
		},
		computed: {
			c_val_date: {
				get: function() {
					return this.c_val ? utilDate.isoToHumanDate(this.c_val, this.c_withTime) : null;
				},
				set: function(humanStringToSetOrNull) {
					if (humanStringToSetOrNull === null) {
						this.c_val = null;
					}
					else if (humanStringToSetOrNull) {
						// если открыть календарь и ткнуть в свободное место вокруг,
						// он закроется, присвоив пустую строку
						var toSetXtra = {};
						var newDatetime = utilDate.isoUpdateHumanDate(this.c_val, humanStringToSetOrNull, toSetXtra, this.c_withTime);
						this.c_val = newDatetime;
					}
				}
			},
			// это дата (комбинированная) которая попадает в модель
			c_val: {
				get: function() {
					return this.$props.value || null;
				},
				set: function(newVal) {
					var emptyValue = this.$props.view_type === 'filter' ? void 0 : null; // в фильтре мы не умеем искать по null и пустое поле == не искать по этому полю. В карточке и списке пустое поле == пустое поле.
					var val = newVal || emptyValue;
					if (newVal != this.c_val) { // защита от например тройной отправки при ред из списка
						this.$emit('update:value', val);
						this.mixin_saveEvent(); // после update:value, иначе PIRS-23248
					}
				}
			},
			c_withTime: function(){
				return !!this.c_ctrlParams.enableTime;
			},
			c_nonrequired: function(){
				return !this.$props.field_meta.required;
			},
			wrapClasses: function(){
				var cls = 'jcal datetime_wrap';
				cls += ' jcal-isCard_' + (this.$props.view_type === 'card');
				cls += ' jcal-isList_' + (this.$props.view_type === 'list');
				cls += ' jcal-withTime_' + this.c_withTime;
				cls += ' jcal-rangeSearch_' + this.$props.range_search_type;
				return cls;
			},
		},
		created: function() {
		},
		mounted: function() {
			var vm = this;
			if (!window.$.datepicker) {
				console.error('Для работы компонента требуется либа jQueryUI');
				return
			}
			// Заглушка, тупо объект из локализации а-ля РЖД
			var Lang = {
				Months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
				WeekDays: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
				WeekDaysShort: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
			};
			var opts = { // https://api.jqueryui.com/datepicker/
				dateFormat: 'dd.mm.yy',
				showAnim: '',
				changeYear: true,
				changeMonth: true,
				classes: 'rrrrr',
				yearRange: '1750:+10', // The range of years displayed in the year drop-down: either relative to today's year ("-nn:+nn"), relative to the currently selected year ("c-nn:c+nn"), absolute ("nnnn:nnnn"), or combinations of these formats ("nnnn:-nn"). Note that this option only affects what appears in the drop-down
				hideIfNoPrevNext: true,
				monthNames: Lang.Months,
				monthNamesShort: Lang.Months,
				dayNames: daysCopy(Lang.WeekDays),
				dayNamesMin: daysCopy(Lang.WeekDaysShort),
				firstDay: 1,
				numberOfMonths: 1,
				currentText : 'Сегодня',
				closeText  : 'Закрыть',
				gotoCurrent: false,
				showButtonPanel : true,
				onSelect: function(dateStr, dpInstance) {
					vm.setDate(dateStr);
					vm.mixin_inputEvent(); // для черновиков. Если его поместить рядом с mixin_saveEvent, будет PIRS2018-3531
					vm.invokeTimeWatcherForMaxDate();
				},
				onClose: function(){},
				beforeShow: function(inp, dpInstance) {
					if (vm.$props.show_in_popup) {
						dpInstance.dpDiv[0].setAttribute('show_in_popup', true);
					}
				},
			}
			/*
			if (vm.$props.mindate) {
				opts.minDate = vm.$props.mindate;
			}
			if (vm.$props.maxdate) {
				opts.maxDate = vm.$props.maxdate;
			}
			*/

			window.$(this.getInp()).datepicker(opts);

			if (vm.$props.is_new_record && vm.$props.field_meta.required) {
				var curDateObj = utilDate.getCurrentDate();

				// добавляем к умолчательной дате модификаторы
				const dateMods = vm.c_ctrlParams?.defaultDateModifiers || [];
				for (const ddm of dateMods) {
					curDateObj = utilDate.add(curDateObj, ddm.qty, ddm.unit);
				}

				vm.c_val_date = utilDate.dateObjToHumanDate(curDateObj); // vm.c_val = utilDate.dateObjToToIso(curDateObj);
				var mskDateObj = new Date(curDateObj.getUTCFullYear(), curDateObj.getUTCMonth(), curDateObj.getUTCDate()); // UTC date
				if (vm.$props.field_meta.ctrlParams.enableTime) {
					// console.log('local datetime to UTC', curDateObj);
					vm.$data.timeHours = vm.leftpad(curDateObj.getUTCHours() + 3); // utilDate.isoGet(this.c_val, 'hour') PIRS-2-8830
					vm.$data.timeMinutes = vm.leftpad(curDateObj.getMinutes()); // utilDate.isoGet(this.c_val, 'minute')
				}
				window.$(this.getInp()).datepicker('setDate', mskDateObj);
			}

			// TODO: Проверить, и если что удалить данную функцию.
			if (vm.c_val && vm.c_withTime === false && this.$props.range_search_type !== 'max') {
				vm.c_val = utilDate.clearTimezoneHumanDate(vm.c_val);
			}

			function daysCopy(src) {
				var i, dst: number[] = [];
				for (i = 1; i != 8; i++) dst[i % 7] = src[i - 1];
					return dst;
			}
		},
		watch: {
			value: function(newVal) {
				// console.log('Datetime value watch: ', newVal);
				// это для сброса даты в фильтре по кнопку Очистить формы
				// сорри, другие способы потенциально (могут быть побочные эффекты)
				// ведут к новому головняку с контролом, поэтому так
				if (newVal === 'DATETIME_CLEARFIELD') {
					this.clearField();
				}
			},
			timeHours: getTimeWatcher(true),
			timeMinutes: getTimeWatcher(false),
		},
		data: function(){
			var val = this.$props.value;
			return {
				// RST: this.$props.range_search_type,
				input_name: 'jqui-datepicker-' + Math.floor(Math.random() * 1e10),
				timeHours: val ? this.leftpad(utilDate.isoGet(val, 'hour')) : this.getDefaultTimeHours(),
				timeMinutes: val ? this.leftpad(utilDate.isoGet(val, 'minute')) : this.getDefaultTimeMinutes(),
			}
		}
	}

	// Функция, которая ВОЗВРАЩАЕТ вотчер для установки времени
	// причём последовательно вызвать этот вотчер (руками через apply например) НЕ ВЫЙДЕТ потому что обновление минут прибьёт часы, потому что часы к тому моменту ещё не дойдут до модели "сверху" через пропс
	// надо было геттер-сеттер, наверное
	function getTimeWatcher(isHours) {
		var unit = isHours ? 'hour' : 'minute';
		//var propName = isHours ? 'timeHours' : 'timeMinutes';
		return function(v) {
			// this.$data[propName] = v;
			var toSet = {
				'second': this.$props.range_search_type === 'max' ? '59' : '00',
			};
			toSet[unit] = v;
			this.c_val = utilDate.isoUpdate(this.c_val, toSet);
		}
	}


